import Katex from 'katex';
import 'katex/dist/contrib/mhchem.js';
import renderMathInElement from 'katex/dist/contrib/auto-render.js';

window.Katex = Katex;
window.renderMathInElement = renderMathInElement;
